import { render, staticRenderFns } from "./suporte-anestesistas.vue?vue&type=template&id=dc4e03e6"
import script from "./suporte-anestesistas.vue?vue&type=script&lang=ts"
export * from "./suporte-anestesistas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports